<template>
  <v-container grid-list-xl>
    <h1 class="display-1">Prüfungssets</h1>
    <v-layout row>
      <v-flex>
        <v-autocomplete
          :items="verfahren"
          item-text="ID"
          label="Verfahren"
          v-model="selectedVerfahren"
          @change="urlVerfahren"
          return-object
        />
      </v-flex>
      <v-flex>
        <v-autocomplete
          :items="standorte"
          menu-props="auto"
          item-text="Standort"
          label="Standort"
          v-model="selectedStandort"
          @change="urlStandort"
          return-object
        />
      </v-flex>
    </v-layout>
    <v-flex>
      <v-data-table
        :loading="isLoading"
        :headers="headers"
        :items="visibleSets"
        no-data-text="Keine Sets vorhanden"
        hide-actions
        class="elevation-1"
      >
        <template slot="items" slot-scope="props">
          <td>
            <img class="row-img" :src="imgPath(props.item)" />
          </td>
          <td>
            <router-link
              :to="{
                name: 'SingleSet',
                params: { setId: props.item.ID },
                query: { s: selectedStandort.Standort }
              }"
              >{{ props.item.Bezeichnung }}</router-link
            >
          </td>
          <td>{{ props.item.produktarten.map(m => m.ID).join(', ') }}</td>
          <td>{{ itemAnzahl(props.item) }}</td>
        </template>
      </v-data-table>
      <v-btn color="primary" @click="createSet">Neues Set</v-btn>
    </v-flex>
  </v-container>
</template>

<script>
import sortby from 'lodash.sortby';
import utils from '@/utils.js';

export default {
  name: 'SetsMainPage',
  data() {
    return {
      isLoading: true,
      loadingProgress: 0,
      headers: [
        { text: '', sortable: false },
        { text: 'Bezeichnung', value: 'Bezeichnung' },
        { text: 'Produktart', value: 'Produktart', sortable: false },
        { text: 'Prüfungsstücke', value: 'anzahl', sortable: true }
      ],
      verfahren: [],
      standorte: [],
      selectedVerfahren: null,
      selectedStandort: null,
      allSets: []
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      try {
        this.isLoading = true;
        const [verfahren, standorte, sets] = await Promise.all([
          this.$http.get('verfahren'),
          this.$http.get('standort'),
          this.$http.get('pruefungsset')
        ]);

        this.verfahren = verfahren.body;

        var tmpStandorte = [{ StandortID: -1, Standort: 'Alle' }];

        tmpStandorte.push(...sortby(standorte.body, ['Standort']));

        this.standorte = tmpStandorte;
        this.allSets = sets.body;

        var urlStandort = this.$route.query.s;
        var urlVerfahren = this.$route.query.v;

        if (urlStandort) {
          this.selectedStandort = this.standorte.find(
            f => f.Standort.toLowerCase() === urlStandort.toLowerCase()
          );
        } else {
          this.selectedStandort = this.standorte[0];
        }

        if (urlVerfahren) {
          this.selectedVerfahren = this.verfahren.find(
            f => f.ID.toLowerCase() === urlVerfahren.toLowerCase()
          );
        } else {
          this.selectedVerfahren = verfahren.body[0];
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.isLoading = false;
      }
    },
    createSet() {
      this.$router.push({ name: 'CreateSet' });
    },
    imgPath(set) {
      if (set && set.img) {
        return utils.getImagePath(this.$http.options.root, set.img);
      }
      return null;
    },
    urlStandort(val) {
      var info = {
        ...this.$route.query
      };

      info.s = val.Standort;

      this.$router.push({ query: info });
    },
    urlVerfahren(val) {
      var info = {
        ...this.$route.query
      };

      info.v = val.ID;

      this.$router.push({ query: info });
    },
    itemAnzahl(set) {
      if (!this.selectedStandort || this.selectedStandort.StandortID === -1) {
        return set.anzahl;
      }

      var standortSet = set.standorte.find(
        f => f.StandortID === this.selectedStandort.StandortID
      );

      return standortSet ? standortSet.anzahl : -1;
    }
  },
  computed: {
    visibleSets() {
      const selected = this.selectedVerfahren;
      const ort = (this.selectedStandort || {}).StandortID || -1;

      return this.allSets.filter(
        s =>
          s.Verfahren === selected.ID &&
          (ort === -1 ||
            s.standorte.filter(io => io.StandortID === ort).length > 0)
      );
    }
  }
};
</script>

<style scoped>
.row-img {
  max-height: 64px;
  max-width: 64px;
}
</style>
